import { Badge, BadgeVariant } from '../../../components/atoms/badge/badge';
import {
  STATUS_KYC_LABEL,
  StatusKycCliente,
} from '../../../types/cliente';

const variantByStatus: Record<StatusKycCliente, BadgeVariant> = {
  [StatusKycCliente.NAO_INICIADO]: 'neutral',
  [StatusKycCliente.PENDENTE]: 'warning',
  [StatusKycCliente.APROVADO]: 'success',
  [StatusKycCliente.REPROVADO]: 'danger',
};

interface Props {
  status: StatusKycCliente | null;
  description?: string | null;
}

export const ClienteKycBadge = ({ status, description }: Props) => {
  if (status == null) {
    return <Badge variant="neutral">Sem KYC</Badge>;
  }
  return (
    <Badge variant={variantByStatus[status] ?? 'neutral'}>
      {description ?? STATUS_KYC_LABEL[status] ?? 'Desconhecido'}
    </Badge>
  );
};
